import {
  GET_ORGANISER_SUCCESS,
  GET_ORGANISER_FAILURE,
  GET_ORGANISER_LOADING,
  GET_LIVE_EVENTS_SUCCESS,
  GET_LIVE_EVENTS_FAILURE,
  GET_LIVE_EVENTS_LOADING,
  GET_PAST_EVENTS_SUCCESS,
  GET_PAST_EVENTS_FAILURE,
  GET_PAST_EVENTS_LOADING,
  UPDATE_TAB_PAGE
} from "../actions/organiserActions";

const initialState = {
  organiserLoading: true,
  organiser: null,
  organiserFailure: false,
  tab: "live",
  liveEvents: {
    page: 0,
    loading: false,
    events: null,
    total: 0,
    errors: false
  },
  pastEvents: {
    page: 0,
    loading: false,
    events: null,
    total: 0,
    errors: false
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIVE_EVENTS_LOADING:
      return {
        ...state,
        liveEvents: {
          ...state.liveEvents,
          page: action.page,
          loading: true
        }
      };
    case GET_LIVE_EVENTS_SUCCESS:
      return {
        ...state,
        liveEvents: {
          ...state.liveEvents,
          loading: false,
          events: action.events,
          total: action.numEvents
        }
      };
    case GET_LIVE_EVENTS_FAILURE:
      return {
        ...state
      };
    case GET_PAST_EVENTS_LOADING:
      return {
        ...state,
        pastEvents: {
          ...state.pastEvents,
          page: action.page,
          loading: true
        }
      };

    case GET_PAST_EVENTS_SUCCESS:
      return {
        ...state,
        pastEvents: {
          ...state.pastEvents,
          loading: false,
          events: action.events,
          total: action.numEvents
        }
      };
    case GET_PAST_EVENTS_FAILURE:
      return {
        ...state
      };

    case GET_ORGANISER_FAILURE:
      return {
        ...state,
        organiserFailure: true
      };
    case GET_ORGANISER_LOADING:
      return {
        ...state,
        organiserLoading: true
      };
    case GET_ORGANISER_SUCCESS:
      return {
        ...state,
        organiser: action.organiser,
        organiserLoading: false
      };
    case UPDATE_TAB_PAGE:
      return {
        ...state,
        tab: action.tab
      };
    default:
      return state;
  }
};
export default { initialState, reducer };
